
//Iscrição Estadual

import React from 'react';

function InscEstField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input
        type="text"
        placeholder="Digite a Inscrição Estadual"
        style={{ width: '200px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
       />
    </div>
  );
}

export default InscEstField;
